import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appClickCatcher]'
})
export class ClickCatcherDirective {

  constructor() { }
  @HostListener('window:click', ['$event']) onClick(event: any) {
    alert(`You clicked on ${event.target}`);
  } 
}
